import { Component, OnInit, ViewEncapsulation,ElementRef, ViewChild, Optional, Inject } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/api.service';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';

@Component({
  selector: 'app-edit-poll',
  templateUrl: './edit-poll.component.html',
  styleUrls: ['./edit-poll.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EditPollComponent implements OnInit {
  allGroups = [];
  bmList = [];
  newPollData = new FormGroup({
    name: new FormControl('', Validators.required),
    description: new FormControl(''),
    message: new FormControl('', Validators.required),
    pollType: new FormControl('', Validators.required),
    allowVoteChange: new FormControl('', Validators.required),
    adhoc: new FormControl(''),
    isLive: new FormControl(''),
    optIn: new FormControl(''),
    group: new FormControl('{}'),
    expTime: new FormControl('', Validators.required),
    close_message: new FormControl(''),
  });
  time={};
  expTime;
  isLinear = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  pollTypes = ['poll','quiz','elections','ranked-choice'];
  selectedPollType = 'quiz';
  allowVote ;
  adhoc;
  optIn;
  myDatePicker;
  myDate = new Date();
  pollInfo;

  options=[{Name:'',showInput:false,Description:'',replayValues:[],id:'',group:null},
  {Name:'',showInput:false,Description:'',replayValues: [],id:'',group:null},
  ];
  optionList;
  correctOptionId;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  sections = [];
  selectedSections;

  correctOptionValue = 7;
  // replayValues = [];
  @ViewChild('stepper') stepper: MatStepper;
  constructor(
    public dialogRef: MatDialogRef<EditPollComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private router:Router) {
      this.pollInfo = data.poll;
      this.allGroups = data.allGroups;
      this.bmList = data.bmList;
      console.log(this.pollInfo);
      // this.sections = this.bmList;
      
    }

  

  addSection(event) {
    if (event && event.option) {
      const id = event.option.value._id;
      this.selectedSections.push(event.option.value);
      this.sections.splice(this.sections.indexOf(event.option.value), 1);
    }
  }

  removeSelectedSection(selectedSection) {
    this.selectedSections.splice(this.selectedSections.indexOf(selectedSection), 1);
    this.sections.push(selectedSection);
  }

  ngOnInit(): void {
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
    this.selectedPollType = this.pollInfo.poll_type;
    this.newPollData.controls['name'].setValue(this.pollInfo.name);
    this.newPollData.controls['description'].setValue(this.pollInfo.description);
    this.newPollData.controls['message'].setValue(this.pollInfo.message);
    this.newPollData.controls['pollType'].setValue(this.pollInfo.poll_type);
    this.newPollData.controls['allowVoteChange'].setValue(this.pollInfo.allow_vote_change);
    this.newPollData.controls['adhoc'].setValue(this.pollInfo.adhoc);
    this.newPollData.controls['isLive'].setValue(this.pollInfo.is_live);
    this.newPollData.controls['optIn'].setValue(this.pollInfo.is_optin);
    this.newPollData.controls['close_message'].setValue(this.pollInfo.closing_message);
    this.adhoc = this.pollInfo.adhoc;
    this.optIn = this.pollInfo.is_optin;
    this.allowVote = this.pollInfo.allow_vote_change;
    var seconds = this.pollInfo.expiry_time;
    var hours    = Math.floor(seconds / (60*60));
      seconds -= hours   * (60*60);
    var minutes  = Math.floor(seconds / (60));
      seconds -= minutes * (60);
    
    let expTime = hours +':'+ minutes;
    this.newPollData.controls['expTime'].setValue(expTime);
    if(this.adhoc){
      this.selectedSections = [];
      for(let i=0; i<this.pollInfo.members.length;i++){
        let index = this.bmList.map(function(e) { return e.id; }).indexOf(this.pollInfo.members[i]);
        let user = this.bmList[index];
        console.log(this.pollInfo.members[i])
        this.selectedSections.push(user);
      }
      for(let i=0; i<this.bmList.length;i++){
        if (this.selectedSections.filter(e => e.name === this.bmList[i].name).length == 0) {
          this.sections.push(this.bmList[i]);
        }
      }

      // for(let i=0; i<this.bmList.length;i++){
      //   if (this.pollInfo.members.filter(e => e.id == this.bmList[i].id).length == 0) {
      //     this.sections.push(this.bmList[i]);
      //   }else{
      //     this.selectedSections.push(this.bmList[i]);
      //   }
      // }
      
      
    }else{
      let index = this.allGroups.map(function(e) { return e.id; }).indexOf(this.pollInfo.group_id);
      let selectedGroup = this.allGroups[index];
      this.newPollData.controls['group'].setValue(selectedGroup);
    }
    this._apiService.getPollOptionList(this.pollInfo.id).subscribe(res => {
      if (res) {
        console.log(res);
        this.optionList = res;
        this.options = [];
        for(let i = 0; i < this.optionList.length; i++){
          let geoupInOption = this.allGroups.filter(e => e.id === this.optionList[i].group_id)[0];
          if(this.optionList[i].similar){
            this.options.push({Name:this.optionList[i].name,showInput:false,Description:this.optionList[i].description,replayValues:this.optionList[i].similar,id:this.optionList[i].id,group:geoupInOption});
          }else{
            this.options.push({Name:this.optionList[i].name,showInput:false,Description:this.optionList[i].description,replayValues:[],id:this.optionList[i].id,group:geoupInOption});
          }
          
        }
        console.log(this.options);
      }
    },
    (error)=>{
      console.log(error);
    });
    
    console.log(this.newPollData);

  }


  createNewPoll(){
    if (this.newPollData.valid) {
      // return;
      let memberIdList = [];
      
      let time = this.newPollData.get('expTime').value;
      let timeInsec = time.split(':')[0]*3600 + time.split(':')[1]*60;
      this.selectedPollType = this.newPollData.get('pollType').value;
      console.log(timeInsec);
      let pollData ;
      if(this.adhoc){
        for (let i = 0; i < this.selectedSections.length; i++) {
          memberIdList.push(this.selectedSections[i].id);
        }
        pollData = {
          name: this.newPollData.get('name').value,
          description: this.newPollData.get('description').value,
          message: this.newPollData.get('message').value,
          poll_type: this.newPollData.get('pollType').value,
          allow_vote_change: this.newPollData.get('allowVoteChange').value,
          group_id: '',
          adhoc: this.newPollData.get('adhoc').value,
          is_live: this.newPollData.get('isLive').value,
          expiry_time: timeInsec,
          members:memberIdList,
          is_optin: this.newPollData.get('optIn').value,
          closing_message: this.newPollData.get('close_message').value,
        }
      }else {
        pollData = {
          name: this.newPollData.get('name').value,
          description: this.newPollData.get('description').value,
          message: this.newPollData.get('message').value,
          poll_type: this.newPollData.get('pollType').value,
          allow_vote_change: this.newPollData.get('allowVoteChange').value,
          group_id: this.newPollData.get('group').value.id,
          adhoc: this.newPollData.get('adhoc').value,
          is_live: this.newPollData.get('isLive').value,
          expiry_time: timeInsec,
          members:'',
          is_optin: this.newPollData.get('optIn').value,
          closing_message: this.newPollData.get('close_message').value,
        }
      }
      if(this.pollInfo){
        pollData.id = this.pollInfo.id;
        let updateType = 'new';
        this.updatePoll(pollData,updateType);
        // id:this.pollInfo.id

      }else{
        this._apiService.createNewPoll(pollData).subscribe(res => {
          if (res) {
            console.log(res);
            this.pollInfo = res;
            this._snackBar.open('Poll created', 'OK', { duration: 3000 });
          }
        },
        (error)=>{
          console.log(error);
        });
      }

    }


    
    
  }


  handleAdd(){
    console.log(this.options);
    let instance={Name:'',showInput:true,Description:'',replayValues: [],id:'',group:null};
    this.options.splice(this.options.length,0,instance);
  }
  handleCancel(index){
    if(this.options.length >2){
      this.options.splice(index,1);
    }else{
      this._snackBar.open('The options count cannot be less than two.', 'OK', { duration: 3000 })
    }
  }

  handleSavePollOptions(){
      let pollOption =[];
      let pollOptionInstance = {}
      for (let i = 0; i < this.options.length; i++){
        if(this.options[i].Name && this.options[i].Description && this.options[i].replayValues.length > 0){
          if(this.pollInfo.is_optin && this.options[i].group){
            pollOptionInstance = {
              "name":this.options[i].Name,
              "description":this.options[i].Description,
              "option_type":this.pollInfo.poll_type,
              "poll_id":this.pollInfo.id,
              "group_id": this.options[i].group.id,
              "id":this.options[i].id,
              "similar":this.options[i].replayValues
            }
          }else {
            pollOptionInstance = {
              "name":this.options[i].Name,
              "description":this.options[i].Description,
              "option_type":this.pollInfo.poll_type,
              "poll_id":this.pollInfo.id,
              "id":this.options[i].id,
              "similar":this.options[i].replayValues
            }
          }
          
          pollOption.push(pollOptionInstance);
        }else if(this.selectedPollType = 'ranked-choice'){
          pollOptionInstance = {
            "name":this.options[i].Name,
            "description":'ranked-choice',
            "option_type":this.pollInfo.poll_type,
            "poll_id":this.pollInfo.id, 
            "id":this.options[i].id,
            "similar":this.options[i].replayValues
          }
          pollOption.push(pollOptionInstance);
        }else{
          pollOption = [];
          this._snackBar.open('First fill all the inputs then try to create option.', 'OK', { duration: 3000 })
          return;
        }
          
      }

      this.updatePollOption(pollOption);
      this.stepper.next();
  }

  updatePollOption(data){
    this._apiService.addPollOptions(data).subscribe(res => {
      if (res) {
        console.log(res);
        this.optionList = res;
        this.options = [];
        for(let i = 0; i < this.optionList.length; i++){
          if(this.optionList[i].group_id){
            let geoupInOption = this.allGroups.filter(e => e.id === this.optionList[i].group_id)[0];
            this.options.push({Name:this.optionList[i].name,showInput:false,Description:this.optionList[i].description,replayValues:this.optionList[i].similar,id:this.optionList[i].id,group:geoupInOption});
          }else {
            this.options.push({Name:this.optionList[i].name,showInput:false,Description:this.optionList[i].description,replayValues:this.optionList[i].similar,id:this.optionList[i].id,group:null});
          }
        }
        this._snackBar.open('Poll Options added successfully', 'OK', { duration: 3000 });
        if(this.selectedPollType == 'poll' || this.selectedPollType == 'elections' || this.selectedPollType == 'ranked-choice' ){
          this.dialogRef.close();
        }
      } 
    },
    (error)=>{
      console.log(error);
    });
  }


  onRadioButtonValueChange(id){
    this.correctOptionId  = id;
    this.correctOptionId = id;
  }
  

  updatePollsWithCorrectOption(){
    let correctOptionInfo = {
      name: this.pollInfo.name,
      description: this.pollInfo.description,
      message: this.pollInfo.message,
      poll_type: this.pollInfo.poll_type,
      allow_vote_change: this.pollInfo.allow_vote_change,
      group_id: this.pollInfo.group_id,
      adhoc: this.pollInfo.adhoc,
      expiry_time: this.pollInfo.expiry_time,
      members:this.pollInfo.members,
      correct_option: this.correctOptionId,
      id:this.pollInfo.id,
      is_live: this.pollInfo.is_live,
      is_optin: this.pollInfo.is_optin,
      closing_message: this.pollInfo.closing_message
    }
    let updatrType = 'pollOption';
    this.updatePoll(correctOptionInfo,updatrType);
  }

  updatePoll(data,type){
    
    this._apiService.updatePolls(data).subscribe(res => {
      if (res) {
        this.pollInfo = res;
        console.log(res);
        if(type == 'pollOption'){
          this.dialogRef.close();
        }
        
        // this.router.navigateByUrl('home/board-member', { skipLocationChange: true })
        // .then(() => {this.router.navigate(['home/execute']);}); 
      }
    },
    (error)=>{
      console.log(error);
    });
  }

  add(event: MatChipInputEvent, index): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      let instance = this.options[index].replayValues;
      instance.push(value.trim());
      this.options[index].replayValues = instance;
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(replayIndex,index): void {
    let instance = this.options[index].replayValues;
    instance.splice(replayIndex,1);
    this.options[index].replayValues = instance;
  }
}
